import React from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const AboutDialog = ({ onClose, serverVersion }) => {
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>About WakeSMART</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 1, mt: 3, textAlign: 'center' }}>
                    <Typography>Product made by: Raptor Technical LLC</Typography>
                    <a href="https://raptortechnical.com" target="_blank">
                        https://raptortechnical.com
                    </a>
                    <Typography>Server Version: {serverVersion}</Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Button onClick={onClose} color="primary" variant="contained">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AboutDialog.propTypes = {
    onClose: PropTypes.func,
    serverVersion: PropTypes.string
};

export default AboutDialog;
